module.exports = __webpack_public_path__ + "assets/img/37_1459.63145595.jpg";